import { registerLocaleData } from '@angular/common';
import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import en from '@angular/common/locales/en';
import vi from '@angular/common/locales/vi';
import { APP_INITIALIZER, ApplicationConfig, ErrorHandler, importProvidersFrom, isDevMode } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideNzI18n, vi_VN } from 'ng-zorro-antd/i18n';
import { provideNzIcons } from 'ng-zorro-antd/icon';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { provideToastr } from 'ngx-toastr';
import { routes } from './app.routes';
import { icons } from './icons-provider';
import { httpInterceptor } from './interceptors/http.interceptor';
import { initApm } from './apm.config';
import { ApmErrorHandler, ApmModule, ApmService } from '@elastic/apm-rum-angular';
import { provideServiceWorker } from '@angular/service-worker';
import { provideLottieOptions } from 'ngx-lottie';
import player from 'lottie-web';
import { provideQuillConfig } from 'ngx-quill';
// Factory function để tạo TranslateLoader

const basePath = window.location.pathname.includes('s-o-t') ? "/s-o-t/" : "/";
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, `${basePath}assets/i18n/`, '.json');
}

registerLocaleData(en);
registerLocaleData(vi);

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptors([httpInterceptor])),
    provideRouter(routes),
    provideNzIcons(icons),
    provideNzI18n(vi_VN),
    importProvidersFrom(
      FormsModule,
      NzModalModule,
      TranslateModule.forRoot({
        defaultLanguage: 'vi',
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
        }
      })
    ),
    provideAnimationsAsync(),
    provideAnimations(),
    provideToastr({
      timeOut: 3000,
      positionClass: 'toast-top-center',
      preventDuplicates: true,
    }),

    importProvidersFrom(ApmModule),
    ApmService,
    {
      provide: APP_INITIALIZER,
      useFactory: initApm,
      deps: [ApmService],
      multi: true,
    },
    {
      provide: ErrorHandler,
      useClass: ApmErrorHandler,
    }, provideServiceWorker('service-worker.js', {
            enabled: !isDevMode(),
            registrationStrategy: 'registerWhenStable:30000'
    }),
    provideLottieOptions({
      player: () => player
    }),
    provideQuillConfig({
      modules: {
        toolbar: [
          ['bold', 'italic', 'strike'], 
          ['code'],
          [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        ]
      },
      theme: 'bubble'
    }),
  ]
};
